export default __webpack_public_path__ + "assets/images/create-template.png";